import type { Account } from "@eai-toolkit/client";

import {
  type BaseQueryState,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateFromStringBase,
} from "../utils/queryStateUtils";

export type AccountsQueryState = BaseQueryState<Account>;

const DEFAULT_ACCOUNT_SORT: AccountsQueryState["query"]["sort"] = {
  fieldName: "fullName",
  direction: "asc",
};

export function hydrateAccountsQueryStateFromString(
  searchString: string,
): AccountsQueryState {
  return hydrateQueryStateFromStringBase<Account>(searchString, {
    defaultSort: DEFAULT_ACCOUNT_SORT,
    defaultLimit: 10,
  });
}

export function dehydrateAccountsQueryStateToString(
  queryState: AccountsQueryState,
): string {
  return dehydrateQueryStateToStringBase<Account>(queryState);
}
